module.exports = __webpack_public_path__ + "static/media/checkmark_118.3335a28e.png";